var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPatient = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 14,
  cy: 14,
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.797 20.522a41.16 41.16 0 0 1 3.9-1.552c.73-.27.611-2.178.287-2.533a5.388 5.388 0 0 1-1.403-4.177A3.52 3.52 0 0 1 14 8.402a3.52 3.52 0 0 1 3.419 3.858 5.388 5.388 0 0 1-1.403 4.177c-.324.36-.443 2.262.287 2.533a41.16 41.16 0 0 1 3.9 1.552",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export { SvgIconPatient as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-patient.svg";